import useMetaTracking, { UseMetaTrackingProps } from '@common/hooks/useMetaTracking';
import usePostHogTracking from '@common/hooks/usePostHogTracking';
import { useCallback } from 'react';

interface UseTrackingProps {
  meta?: UseMetaTrackingProps;
}

export const useTracking = (props: UseTrackingProps = {}) => {
  const posthog = usePostHogTracking();
  const meta = useMetaTracking(props.meta);

  const trackEvent = useCallback(
    (eventName: string, properties?: Record<string, unknown>) => {
      posthog.trackEvent(eventName, properties);
      meta.trackEvent(eventName, properties);
    },
    [posthog.trackEvent, meta.trackEvent]
  );

  return {
    posthog,
    meta,
    trackEvent,
  };
};
